// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Reducer$LiteracyplanetTupperware from "../Reducer.res.mjs";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V3MultliChoiceStyleContext$LiteracyplanetTupperware from "./V3MultliChoiceStyleContext.res.mjs";
import * as V2ExerciseStateStoreContext$LiteracyplanetTupperware from "../v2/V2ExerciseStateStoreContext.res.mjs";

var Sig = {
  name: "MultiChoiceApi"
};

var MultiChoiceApi = ContextMaker$LiteracyplanetClientFlags.Make(Sig);

function V3MultiChoiceOptionContext(props) {
  var responseOptionId = props.responseOptionId;
  var questionIndex = props.questionIndex;
  var group = props.group;
  var match = V2ExerciseStateStoreContext$LiteracyplanetTupperware.useDispatch();
  var dispatch = match[1];
  var layout = Curry._1(V3MultliChoiceStyleContext$LiteracyplanetTupperware.use, undefined);
  var match$1 = V2ExerciseContext$LiteracyplanetTupperware.use();
  var isResponseSelected = match$1.isResponseSelected;
  var getStep = match$1.getStep;
  var match$2;
  if (typeof layout !== "object") {
    match$2 = layout === "MultiChoiceRadio" ? [
        (function (param) {
            Curry._1(dispatch, {
                  TAG: "SetQuestionState",
                  _0: questionIndex,
                  _1: Reducer$LiteracyplanetTupperware.buildResponseType(group, responseOptionId),
                  _2: "ResponseMarkingWithDistractors"
                });
          }),
        Curry._2(isResponseSelected, questionIndex, responseOptionId),
        Reducer$LiteracyplanetTupperware.getMarkType(Curry._1(getStep, questionIndex), responseOptionId),
        undefined
      ] : [
        (function (param) {
            Curry._1(dispatch, {
                  TAG: "SetQuestionState",
                  _0: questionIndex,
                  _1: Reducer$LiteracyplanetTupperware.buildResponseType(group, responseOptionId),
                  _2: "ResponseMarking"
                });
          }),
        Curry._2(isResponseSelected, questionIndex, responseOptionId),
        Reducer$LiteracyplanetTupperware.getMarkType(Curry._1(getStep, questionIndex), responseOptionId),
        undefined
      ];
  } else {
    var marking = layout.marking;
    var id = Belt_Option.mapWithDefault(group, responseOptionId, (function (setName) {
            return Reducer$LiteracyplanetTupperware.joinAnswerSetPair(setName, responseOptionId);
          }));
    var answerVisible = Curry._1(match$1.isCorrectAnswerVisible, questionIndex);
    var correctAnswer = Curry._1(match$1.getCorrectAnswer, questionIndex);
    match$2 = [
      (function (param) {
          Curry._1(dispatch, {
                TAG: "SetQuestionState",
                _0: questionIndex,
                _1: Reducer$LiteracyplanetTupperware.buildAnswerSetResponseType(group, responseOptionId),
                _2: marking
              });
        }),
      Curry._2(isResponseSelected, questionIndex, id),
      Reducer$LiteracyplanetTupperware.getMarkType(Curry._1(getStep, questionIndex), id),
      answerVisible !== undefined && answerVisible ? (
          correctAnswer !== undefined && Belt_List.some(correctAnswer, (function (l) {
                  return l === id;
                })) ? true : false
        ) : undefined
    ];
  }
  return React.createElement(MultiChoiceApi.Provider.make, {
              value: {
                onClickOption: match$2[0],
                selected: match$2[1],
                marked: match$2[2],
                showThisResponseAsCorrectAnswer: match$2[3]
              },
              children: props.children
            });
}

var use = MultiChoiceApi.use;

var make = V3MultiChoiceOptionContext;

export {
  Sig ,
  MultiChoiceApi ,
  use ,
  make ,
}
/* MultiChoiceApi Not a pure module */
